<template>
  <el-popover
    placement="bottom"
    popper-class="df-popover"
    width="120"
    trigger="click"
  >
    <span class="nf-flex vertical">
      <span
        class="df-action"
        :class="{active: lang === 'en-US'}"
        @click="changeLang('en-US')"
      >English</span>
      <span
        class="df-action"
        :class="{active: lang === 'zh-CN'}"
        @click="changeLang('zh-CN')"
      >简体中文</span>
    </span>
    <span slot="reference">
      <df-nav-item
        slot="reference"
        class="nf-clickable"
      >
        <i class="icon_language"></i>
        <span>{{ TLang('语言','common') }}</span>
        <i class="df-arrow"></i>
      </df-nav-item>
    </span>
  </el-popover>
</template>

<script>
import {getCookie} from "@utils";
import Cookies from "js-cookie";
import { unionFlag } from '../../../utils';

export default {
  name: "Language",
  data() {
    return {
      lang: getCookie('df_lang') || 'zh-CN',
    };
  },
  methods: {
    changeLang(lang) {
      let domain = 'dongfangfuli.com';
      if(window.location.hostname.indexOf(domain) < 0) {
        domain = window.location.hostname;
      }
      Cookies.set("df_lang", lang, { domain: domain });
      // 调取接口
      if (window.df_sdk_common.isBfd()) {
        try {
          this.apis.newBfdHeaderApi.saveLanguage({
            key: 'lang',
            value: lang == 'zh-CN' ? 1 : 2,
          }).then(res => {
            this.reloadPage(lang);
          });
        } catch (error) {
          this.reloadPage(lang);
        }
      } else {
        this.reloadPage(lang);
      }
    },
    reloadPage(lang) {
      if(this.$listeners.onLanguageChange) {
        this.$emit('onLanguageChange', lang);
      } else {
        window.location.reload();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.icon_language {
  // display: inline-block;
  // vertical-align: middle;
  // position: relative;
  // top: -2px;
  // background: url("../imgs/language.svg") no-repeat;
  background: url("../imgs/language.png") no-repeat left center;
  background-size: 16px auto;
  width: 16px;
  height: 16px;
  // background-size: cover;
  margin-right: 4px;
}
</style>
